<template>
  <div class="news-details">
    <AppBar />
    <div class="page-content">
      <div class="details-content-wrap">
        <div class="details-breadcrumb-wrap">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: type==1 ? '/news/huayue' : '/news/industry' }">{{ type == 1 ? '华跃资讯' : '行业资讯' }}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '' }">详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="details-content">
          <div class="content-left">
            <div class="content-wrap">
              <div class="content-title">{{ detailsTitle }}</div>
              <div class="content-time">{{ time }}</div>
              <div class="content-text" v-html="content"></div>
            </div>
            <div class="turn-pages-wrap">
              <div class="turn-pages prev-wrap" :class="{'haveTurn': prevNews.id != 0}" @click="jumpArticle(prevNews.id)">
                <div class="pages">
                  <img :src="require('@/assets/news/icon/prev.png')" alt="" class="icon" />
                  <div class="text">上一篇</div>
                </div>
                <div class="turn-pages-title">{{ prevNews.title }}</div>
              </div>
              <div class="turn-pages next-wrap" :class="{'haveTurn': nextNews.id != 0}" @click="jumpArticle(nextNews.id)">
                <div class="pages">
                  <img :src="require('@/assets/news/icon/next.png')" alt="" class="icon" />
                  <div class="text">下一篇</div>
                </div>
                <div class="turn-pages-title">{{ nextNews.title }}</div>
              </div>
            </div>
          </div>
          <div class="content-right">
            <div class="hot-wrap">
              <div class="hot-tit">
                热门推荐
              </div>
              <div class="hot-news-list">
                <div
                  v-for="(item, index) in hotNewsList"
                  :key="index"
                  class="hot-news-item"
                  @click="jumpArticle(item.id)"
                >
                  <div class="news-time">{{ hotPublishTime(item) }}</div>
                  <div class="news-title">{{ item.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getContentList, getContentDetail } from '@/api/content';
export default {
  name: 'DetailsView',
  data() {
    return {
      columnId: '',
      contentId: 0,
      type: '',
      detailsTitle: '',
      time: '',
      content: '',
      hotNewsList: [
        // {
        //   id: 0,
        //   title: '华跃科技员工专访第二期 ▏心有所向，乘风破浪',
        //   time: '11-04',
        // },
      ],
      prevNews: {
        id: 1,
        title: '凝心聚力创双优--行业500强企业对华跃的产及服务给予高度认可与信任！',
      },
      nextNews: {
        id: 3,
        title: '华跃科技党支部的红色印记',
      },
    };
  },
  watch: {
    '$route': {
      handler(to, from) {
        this.detailsTitle = '';
        this.time = '';
        this.content = '';
        this.type = Number(to.query.type);
        if (Number(to.query.type) === 1) {
          this.columnId = '1605774350588534784';
        } else if (Number(to.query.type) === 2) {
          this.columnId = '1605774444985540608';
        }
        this.contentId = to.params.id;
        this.getNewsDetails();
        this.gethotNews();
      },
      deep: true,
      immediate: true,
    },
  },
  // mounted() {
  //   this.contentId = this.$route.params.id;
  // },
  methods: {
    async getNewsDetails() {
      var res = await getContentDetail(this.contentId);
      var { result, } = res;
      this.detailsTitle = result.title;
      this.time = dayjs(result.publishTime).format('YYYY-MM-DD HH:mm:ss');
      var doc = new DOMParser().parseFromString(result.defaultContent, 'text/html');
      this.content = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
      if (result.afterEssay.id !== 0) {
        this.prevNews = result.afterEssay;
      } else {
        this.prevNews = {
          id: 0,
          title: '暂无',
        };
      }
      if (result.preEssay.id !== 0) {
        this.nextNews = result.preEssay;
      } else {
        this.nextNews = {
          id: 0,
          title: '暂无',
        };
      }
    },
    async gethotNews() {
      var params = { columnId: this.columnId, pageNum: 1, pageSize: 5, commendation: 7, };
      var res = await getContentList(params);
      var { result, } = res;
      this.hotNewsList = result.data;
    },

    jumpArticle(id) {
      if (id !== 0) {
        this.$router.push({ path: `/news/details/${id}`, query: { type: this.type, }, });
      }
    },

    hotPublishTime(item) {
      return dayjs(item.publishTime).format('MM-DD');
    },

    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less">
// .content-text{
//   p{
//     font-family: OPPOSans-R;
//     font-size: 14px;
//     color: #21252b;
//     line-height: 30px;
//     text-indent:2em
//   }
// }
</style>

<style lang="less" scoped>
.news-details{
  background-color: #fff;
  .page-content{
    width: 100%;
    .details-content-wrap{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 90px;
      .details-breadcrumb-wrap{
        width: 100%;
        height: 63px;
        border-bottom: 1px solid #e8ecf3;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin-bottom: 47px;
        ::v-deep .el-breadcrumb{
            .el-breadcrumb__item{
              .el-breadcrumb__inner.is-link{
                color: #606266;
                font-weight: 400;
              }
              &:last-child{
                .el-breadcrumb__inner.is-link{
                  color: #00b0dc;
                  font-weight: 400;
                  cursor: default;
                }
              }
            }
        }
      }
    }
    .details-content{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .content-left{
        width: 766px;
        .content-wrap{
          width: 100%;
          margin-bottom: 48px;
          .content-title{
            font-size: 36px;
            color: #21252b;
            font-family: OPPOSans-R;
            margin-bottom: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .content-time{
            font-family: OPPOSans-R;
            font-size: 14px;
            line-height: 20px;
            color: #5c6066;
            margin-bottom: 45px;
          }
          .content-text{
            width: 100%;
          }
        }
        .turn-pages-wrap{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .turn-pages{
            max-width: 325px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .pages{
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              .icon{
                width: 6px;
                height: auto;
                display: block;
              }
              .text{
                font-family: OPPOSans-M;
                font-size: 18px;
                color: #21252b;
              }
            }
            .turn-pages-title{
              width: 100%;
              font-family: OPPOSans-R;
              font-size: 16px;
              color: #21252b;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .haveTurn {
            cursor: pointer;
            &:hover {
              .pages{
                .text{
                  color: #00b0dc;
                }
              }
            }
          }
          .prev-wrap{
            align-items: flex-start;
            .pages{
              flex-direction: row;
              padding-left: 5px;
              .text{
                margin-left: 5px;
              }
            }
            .turn-pages-title{
                text-align: left;
            }
          }
          .next-wrap{
            align-items: flex-end;
            .pages{
              flex-direction: row-reverse;
              padding-right: 5px;
              .text{
                margin-right: 5px;
              }
            }
            .turn-pages-title{
                text-align: right;
            }
          }
        }
      }
      .content-right{
        width: 380px;
        height: 300px;
        .hot-wrap{
          .hot-tit{
            width: 100%;
            padding-left: 10px;
            border-left: 4px solid #00b0dc;
            font-size: 20px;
            font-family: OPPOSans-R;
            color: #21252b;
            line-height: 22px;
            box-sizing: border-box;
          }
          .hot-news-list{
            width: 100%;
            margin-top: 20px;
            .hot-news-item{
              width: 100%;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 20px;
              cursor: pointer;
              .news-time{
                flex: 1;
                font-family: OPPOSans-R;
                font-size: 12px;
                color: #5c6066;
                line-height: 1;
              }
              .news-title{
                width: 313px;
                font-family: OPPOSans-R;
                font-size: 14px;
                color: #21252b;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
}
</style>
